import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { simWorldCupResult, simWorldCupResultAgain } from "./api";

const initialState = {
    data: { loading: false, year: 2026 }
};

export const simWorldCupResultAsync = createAsyncThunk(
    'worldCupResult/sim',
    async (params) => {
        const response = await simWorldCupResult(params);
        return response.data;
    }
);

export const simWorldCupResultAgainAsync = createAsyncThunk(
    'worldCupResult/simAgain',
    async (worldCupResult) => {
        const response = await simWorldCupResultAgain(worldCupResult);
        return response.data;
    }
);

export const worldCupResultSlice = createSlice({
    name: 'worldCupResult',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(simWorldCupResultAsync.pending, state => {
                state.data.loading = true;
            })
            .addCase(simWorldCupResultAsync.fulfilled, (state, action) => {
                state.data = action.payload;
                state.data.loading = false;
            })
            .addCase(simWorldCupResultAsync.rejected, state => {
                state.data.loading = false;
            })
            .addCase(simWorldCupResultAgainAsync.pending, state => {
                state.data.loading = true;
            })
            .addCase(simWorldCupResultAgainAsync.fulfilled, (state, action) => {
                state.data = action.payload;
                state.data.loading = false;
            })
            .addCase(simWorldCupResultAgainAsync.rejected, state => {
                state.data.loading = false;
            });
    },
});

export const selectWorldCupResult = (state) => state.worldCupResult.data;

export default worldCupResultSlice.reducer;